import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=aad35ca6"
import script from "./callback.vue?vue&type=script&lang=ts"
export * from "./callback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports